export async function fetchPublicImages() {
  const response = await fetch('/api/images');
  if (!response.ok) throw new Error('Bilder konnten nicht geladen werden.');
  const payload = await response.json();
  return payload.images || [];
}

export async function loginAdmin(password) {
  const response = await fetch('/api/admin/session', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ password })
  });

  if (!response.ok) throw new Error('Login fehlgeschlagen.');
  return response.json();
}

export async function fetchAdminImages(password) {
  const response = await fetch('/api/admin/images', {
    headers: { 'x-admin-password': password }
  });

  if (!response.ok) throw new Error('Admin-Bilder konnten nicht geladen werden.');
  const payload = await response.json();
  return payload.images || [];
}

export async function uploadAdminImage(password, formData) {
  const response = await fetch('/api/admin/images', {
    method: 'POST',
    headers: { 'x-admin-password': password },
    body: formData
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new Error(payload.error || 'Upload fehlgeschlagen.');
  }

  return response.json();
}

export async function updateAdminImage(password, id, patch) {
  const response = await fetch(`/api/admin/images/${id}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'x-admin-password': password
    },
    body: JSON.stringify(patch)
  });

  if (!response.ok) throw new Error('Bild konnte nicht aktualisiert werden.');
  return response.json();
}

export async function deleteAdminImage(password, id) {
  const response = await fetch(`/api/admin/images/${id}`, {
    method: 'DELETE',
    headers: { 'x-admin-password': password }
  });

  if (!response.ok) throw new Error('Bild konnte nicht gelöscht werden.');
  return response.json();
}
